import Button from "../../../components/Button/Button";
import { StyledLottie } from "../../../components/ConfettiPage/ConfettiPage.styles";
import lottieAnimation from "../../../assets/svg/lottie_Animation.json";
import { styled } from "styled-components";
import { Header } from "../BankSelection";

const SuccessPage = ({
  fipayLogo,
  onClickCloseIcon,
}: {
  fipayLogo: string;
  onClickCloseIcon: () => void;
}) => {
  return (
    <>
      <Header onClick={onClickCloseIcon}>
        <img src={fipayLogo} alt="logo" />
        <img src="/assets/svg/x-alt.svg" alt="close-icon" />
      </Header>
      <SuccessNote>
        <StyledLottie animationData={lottieAnimation} />
        <div>
          <h2>Success</h2>
          <p>You've successfully connected your accounts</p>
        </div>
      </SuccessNote>
      <Button title="Done" green width={"100%"} padding={"10px 30px"} />
    </>
  );
};

export default SuccessPage;

const SuccessNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h2 {
    text-align: center;
    font-size: 25px;
    font-weight: 900px;
  }
  p {
    text-align: center;
    font-size: 18px;
    font-weight: 700px;
  }
`;
